import { all, takeLatest, put, call } from 'redux-saga/effects';
import {
  onGetClaimsHousingStocksFilterOptions,
  onGetClaimsInsuredRisksFilterOptions,
  onGetClaimsInsuredRiskTypesFilterOptions,
  onGetClaimsCreatedByOrganizationsFilterOptions,
  onGetClaimsOrganizationsWithAccessFilterOptions,
  onGetPoliciesHousingStocksFilterOptions,
  onGetPoliciesInsuranceOrganizationsFilterOptions,
  onGetPoliciesCustomFieldsFilterOptions,
  onGetPoliciesInsuredRiskTypesFilterOptions,
  onGetPoliciesInsuredRisksFilterOptions,
  onGetRisksHousingStocksFilterOptions,
  onGetRisksOrganizationsFilterOptions,
  onGetRisksCompanyCodesFilterOptions,
  onGetRisksCompanyLabelsFilterOptions,
  onGetRisksEconomicUnitsFilterOptions
} from './api';
import {
  getClaimsHousingStocksFilterOptions,
  getClaimsHousingStocksFilterOptionsSucceeded,
  getClaimsHousingStocksFilterOptionsFailed,
  getClaimsInsuredRisksFilterOptions,
  getClaimsInsuredRisksSucceeded,
  getClaimsInsuredRisksFailed,
  getClaimsInsuredRiskTypesFilterOptions,
  getClaimsInsuredRiskTypesFilterOptionsSucceeded,
  getClaimsInsuredRiskTypesFilterOptionsFailed,
  getClaimsCreatedByOrganizationsFilterOptions,
  getClaimsCreatedByOrganizationsFilterOptionsSucceeded,
  getClaimsCreatedByOrganizationsFilterOptionsFailed,
  getClaimsOrganizationsWithAccessFilterOptions,
  getClaimsOrganizationsWithAccessFilterOptionsSucceeded,
  getClaimsOrganizationsWithAccessFilterOptionsFailed,
  getPoliciesHousingStocksFilterOptions,
  getPoliciesHousingStocksFilterOptionsSucceeded,
  getPoliciesHousingStocksFilterOptionsFailed,
  getPoliciesInsuranceOrganizationsFilterOptions,
  getPoliciesInsuranceOrganizationsFilterOptionsSucceeded,
  getPoliciesInsuranceOrganizationsFilterOptionsFailed,
  getPoliciesCustomFieldsFilterOptions,
  getPoliciesCustomFieldsFilterOptionsSucceeded,
  getPoliciesCustomFieldsFilterOptionsFailed,
  getPoliciesInsuredRiskTypesFilterOptions,
  getPoliciesInsuredRiskTypesFilterOptionsSucceeded,
  getPoliciesInsuredRiskTypesFilterOptionsFailed,
  getPoliciesInsuredRisksFilterOptions,
  getPoliciesInsuredRisksFilterOptionsSucceeded,
  getPoliciesInsuredRisksFilterOptionsFailed,
  getRisksHousingStocksFilterOptions,
  getRisksHousingStocksFilterOptionsSucceeded,
  getRisksHousingStocksFilterOptionsFailed,
  getRisksOrganizationsFilterOptions,
  getRisksOrganizationsFilterOptionsSucceeded,
  getRisksOrganizationsFilterOptionsFailed,
  getRisksCompanyCodesFilterOptions,
  getRisksCompanyCodesFilterOptionsSucceeded,
  getRisksCompanyCodesFilterOptionsFailed,
  getRisksCompanyLabelsFilterOptions,
  getRisksCompanyLabelsFilterOptionsSucceeded,
  getRisksCompanyLabelsFilterOptionsFailed,
  getRisksEconomicUnitsFilterOptions,
  getRisksEconomicUnitsFilterOptionsSucceeded,
  getRisksEconomicUnitsFilterOptionsFailed
} from './slice';

// claims filter options workers
export function* getClaimsHousingStocksFilterOptionsWorker() {
  try {
    const response = yield call(onGetClaimsHousingStocksFilterOptions);
    yield put(getClaimsHousingStocksFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getClaimsHousingStocksFilterOptionsFailed());
  }
}

export function* getClaimsInsuredRisksFilterOptionsWorker({ payload }) {
  try {
    const response = yield call(onGetClaimsInsuredRisksFilterOptions, payload);
    yield put(getClaimsInsuredRisksSucceeded(response.data));
  } catch {
    yield put(getClaimsInsuredRisksFailed());
  }
}

export function* getClaimsInsuredRiskTypesFilterOptionsWorker() {
  try {
    const response = yield call(onGetClaimsInsuredRiskTypesFilterOptions);
    yield put(getClaimsInsuredRiskTypesFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getClaimsInsuredRiskTypesFilterOptionsFailed());
  }
}

export function* getClaimsCreatedByOrganizationsFilterOptionsWorker() {
  try {
    const response = yield call(onGetClaimsCreatedByOrganizationsFilterOptions);
    yield put(getClaimsCreatedByOrganizationsFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getClaimsCreatedByOrganizationsFilterOptionsFailed());
  }
}

export function* getClaimsOrganizationsWithAccessFilterOptionsWorker() {
  try {
    const response = yield call(onGetClaimsOrganizationsWithAccessFilterOptions);
    yield put(getClaimsOrganizationsWithAccessFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getClaimsOrganizationsWithAccessFilterOptionsFailed());
  }
}

// policies filter options workers
export function* getPoliciesHousingStocksFilterOptionsWorker() {
  try {
    const response = yield call(onGetPoliciesHousingStocksFilterOptions);
    yield put(getPoliciesHousingStocksFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getPoliciesHousingStocksFilterOptionsFailed());
  }
}

export function* getPoliciesInsuranceOrganizationsFilterOptionsWorker() {
  try {
    const response = yield call(onGetPoliciesInsuranceOrganizationsFilterOptions);
    yield put(getPoliciesInsuranceOrganizationsFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getPoliciesInsuranceOrganizationsFilterOptionsFailed());
  }
}

export function* onGetPoliciesCustomFieldsFilterOptionsWorker({ payload }) {
  try {
    const response = yield call(onGetPoliciesCustomFieldsFilterOptions, payload);
    yield put(getPoliciesCustomFieldsFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getPoliciesCustomFieldsFilterOptionsFailed());
  }
}

export function* getPoliciesInsuredRiskTypesFilterOptionsWorker() {
  try {
    const response = yield call(onGetPoliciesInsuredRiskTypesFilterOptions);
    yield put(getPoliciesInsuredRiskTypesFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getPoliciesInsuredRiskTypesFilterOptionsFailed());
  }
}

export function* getPoliciesInsuredRisksFilterOptionsWorker() {
  try {
    const response = yield call(onGetPoliciesInsuredRisksFilterOptions);
    yield put(getPoliciesInsuredRisksFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getPoliciesInsuredRisksFilterOptionsFailed());
  }
}

// risks filter options workers
export function* getRisksHousingStocksFilterOptionsWorker() {
  try {
    const response = yield call(onGetRisksHousingStocksFilterOptions);
    yield put(getRisksHousingStocksFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getRisksHousingStocksFilterOptionsFailed());
  }
}

export function* getRisksOrganizationsFilterOptionsWorker() {
  try {
    const response = yield call(onGetRisksOrganizationsFilterOptions);
    yield put(getRisksOrganizationsFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getRisksOrganizationsFilterOptionsFailed());
  }
}

export function* getRisksCompanyCodesFilterOptionsWorker() {
  try {
    const response = yield call(onGetRisksCompanyCodesFilterOptions);
    yield put(getRisksCompanyCodesFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getRisksCompanyCodesFilterOptionsFailed());
  }
}

export function* getRisksCompanyLabelsFilterOptionsWorker() {
  try {
    const response = yield call(onGetRisksCompanyLabelsFilterOptions);
    yield put(getRisksCompanyLabelsFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getRisksCompanyLabelsFilterOptionsFailed());
  }
}

export function* getRisksEconomicUnitsFilterOptionsWorker() {
  try {
    const response = yield call(onGetRisksEconomicUnitsFilterOptions);
    yield put(getRisksEconomicUnitsFilterOptionsSucceeded(response.data));
  } catch {
    yield put(getRisksEconomicUnitsFilterOptionsFailed());
  }
}

export default function* filtersSaga() {
  yield all([
    takeLatest(getClaimsHousingStocksFilterOptions.type, getClaimsHousingStocksFilterOptionsWorker),
    takeLatest(getClaimsInsuredRisksFilterOptions.type, getClaimsInsuredRisksFilterOptionsWorker),
    takeLatest(getClaimsInsuredRiskTypesFilterOptions.type, getClaimsInsuredRiskTypesFilterOptionsWorker),
    takeLatest(getClaimsCreatedByOrganizationsFilterOptions.type, getClaimsCreatedByOrganizationsFilterOptionsWorker),
    takeLatest(getClaimsOrganizationsWithAccessFilterOptions.type, getClaimsOrganizationsWithAccessFilterOptionsWorker),
    takeLatest(getPoliciesHousingStocksFilterOptions.type, getPoliciesHousingStocksFilterOptionsWorker),
    takeLatest(
      getPoliciesInsuranceOrganizationsFilterOptions.type,
      getPoliciesInsuranceOrganizationsFilterOptionsWorker
    ),
    takeLatest(getPoliciesCustomFieldsFilterOptions.type, onGetPoliciesCustomFieldsFilterOptionsWorker),
    takeLatest(getPoliciesInsuredRiskTypesFilterOptions.type, getPoliciesInsuredRiskTypesFilterOptionsWorker),
    takeLatest(getPoliciesInsuredRisksFilterOptions.type, getPoliciesInsuredRisksFilterOptionsWorker),
    takeLatest(getRisksHousingStocksFilterOptions.type, getRisksHousingStocksFilterOptionsWorker),
    takeLatest(getRisksOrganizationsFilterOptions.type, getRisksOrganizationsFilterOptionsWorker),
    takeLatest(getRisksCompanyCodesFilterOptions.type, getRisksCompanyCodesFilterOptionsWorker),
    takeLatest(getRisksCompanyLabelsFilterOptions.type, getRisksCompanyLabelsFilterOptionsWorker),
    takeLatest(getRisksEconomicUnitsFilterOptions.type, getRisksEconomicUnitsFilterOptionsWorker)
  ]);
}
